import { render, staticRenderFns } from "./LogoBar.vue?vue&type=template&id=10f70fa8&scoped=true"
import script from "./LogoBar.vue?vue&type=script&lang=js"
export * from "./LogoBar.vue?vue&type=script&lang=js"
import style0 from "./LogoBar.vue?vue&type=style&index=0&id=10f70fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.101.3__lodash@4.17.21_kzgbr7tkrfh4tbz6eswufdvi6i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f70fa8",
  null
  
)

export default component.exports